<template>
  <v-dialog
    :model-value="modelValue"
    max-width="640"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <div class="holiday-premium-detail-modal">
      <header class="holiday-premium-detail-modal__head">
        <h3 class="holiday-premium-detail-modal__title">휴일수당 근무 내역</h3>
        <button type="button" class="holiday-premium-detail-modal__close" aria-label="닫기" @click="emit('close')">
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </header>

      <div class="holiday-premium-detail-modal__body">
        <LoadingOverlay :show="loading" text="불러오는 중..." />

        <p v-if="!loading && rows.length === 0" class="holiday-premium-detail-modal__empty">
          휴일수당 대상 청구 건이 없습니다.
        </p>

        <div v-else-if="!loading" class="holiday-premium-detail-modal__table-wrap">
          <table class="holiday-premium-detail-modal__table">
            <thead>
              <tr>
                <th>일자</th>
                <th>수급자</th>
                <th>plan 시간</th>
                <th class="right">시간</th>
                <th>사유</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in rows" :key="`${row.date}|${row.recipientName}|${idx}`">
                <td class="center">{{ row.date }}</td>
                <td>{{ row.recipientName || '-' }}</td>
                <td class="center">{{ row.planTime }}</td>
                <td class="right">{{ row.hours }}h</td>
                <td>{{ row.reason }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <footer class="holiday-premium-detail-modal__footer">
        <v-btn variant="text" class="btn-close" size="small" @click="emit('close')">닫기</v-btn>
      </footer>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import type { HomeWageHolidayPremiumDetailRow } from '@/policies';

defineProps<{
  modelValue: boolean;
  loading?: boolean;
  rows: HomeWageHolidayPremiumDetailRow[];
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  close: [];
}>();
</script>

<style lang="scss">
@import '@/assets/styles/components/home-wage-premium-adjust';
</style>
